import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginRequest, LoginResult, TestLoginOptions, TestLoginRequest } from "../models/auth.model";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";


@Injectable({
  providedIn: "root",
})
export class SessionDataService {
  constructor(private readonly http: HttpClient) { }

  login$(req: LoginRequest): Observable<LoginResult> {
    return this.http.post<LoginResult>(`${environment.backendUrl}/auth/signin`, req);
  }

  testlogin(option: string, req: TestLoginRequest): Observable<LoginResult> | null {
    return option == TestLoginOptions.Doctor
      ? this.http.post<LoginResult>(`${environment.backendUrl}/auth/signintestdoctor`, req)
      : option == TestLoginOptions.Patient
        ? this.http.post<LoginResult>(`${environment.backendUrl}/auth/signintestpatient`, req)
        : null;
  }

  doctorloginGuid(guid: string): Observable<LoginResult> {
    return this.http.get<LoginResult>(`${environment.backendUrl}/Auth/LoginGuid/${guid}`);
  }

}
